var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V3.99998H22L18 0Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8V4H18L22 8Z",
    fill: "#CBD5E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9,
    width: 22,
    height: 11,
    rx: 1,
    fill: "#6366F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60669 12.135V17H5.80869V12.135H6.60669ZM12.7784 12.135V17H11.9804V13.668L10.4964 17H9.94339L8.45239 13.668V17H7.65439V12.135H8.51539L10.2234 15.95L11.9244 12.135H12.7784ZM17.3482 13.535C17.2222 13.2923 17.0472 13.1103 16.8232 12.989C16.5992 12.863 16.3402 12.8 16.0462 12.8C15.7242 12.8 15.4372 12.8723 15.1852 13.017C14.9332 13.1617 14.7349 13.367 14.5902 13.633C14.4502 13.899 14.3802 14.207 14.3802 14.557C14.3802 14.907 14.4502 15.2173 14.5902 15.488C14.7349 15.754 14.9332 15.9593 15.1852 16.104C15.4372 16.2487 15.7242 16.321 16.0462 16.321C16.4802 16.321 16.8326 16.1997 17.1032 15.957C17.3739 15.7143 17.5396 15.3853 17.6002 14.97H15.7732V14.333H18.4542V14.956C18.4029 15.334 18.2676 15.6817 18.0482 15.999C17.8336 16.3163 17.5512 16.5707 17.2012 16.762C16.8559 16.9487 16.4709 17.042 16.0462 17.042C15.5889 17.042 15.1712 16.937 14.7932 16.727C14.4152 16.5123 14.1142 16.216 13.8902 15.838C13.6709 15.46 13.5612 15.033 13.5612 14.557C13.5612 14.081 13.6709 13.654 13.8902 13.276C14.1142 12.898 14.4152 12.604 14.7932 12.394C15.1759 12.1793 15.5936 12.072 16.0462 12.072C16.5642 12.072 17.0239 12.2003 17.4252 12.457C17.8312 12.709 18.1252 13.0683 18.3072 13.535H17.3482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.92db0c8c97acfc82ee7a555534479a45.svg";
export { ForwardRef as ReactComponent };